module.exports = __webpack_public_path__ + "officialStatic/img/sw-detailList15.7e34887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/sw-detailList15.png
// module id = BSa/
// module chunks = 0